import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.95833 14.0417L4.125 10.2083L5.04167 9.29167L7.95833 12.2083L14.9583 5.20833L15.875 6.125L7.95833 14.0417Z",
		fill: "currentColor"
	})
});
export default SvgCheck;
